function normalizeLocale(code) {
  return String(code || "")
    .trim()
    .toLowerCase()
    .split("-")[0];
}

const AUDIT_LOCALES = new Set(["sn", "zu"]);

const MARKET_NAME_LABELS = {
  sn: {
    ao: "Angola",
    au: "Australia",
    ae: "United Arab Emirates",
    be: "Belgium",
    bw: "Botswana",
    ca: "Canada",
    cd: "DR Congo",
    ch: "Switzerland",
    de: "Germany",
    fr: "France",
    gb: "United Kingdom",
    gh: "Ghana",
    ls: "Lesotho",
    mg: "Madagascar",
    mu: "Mauritius",
    mw: "Malawi",
    mz: "Mozambique",
    na: "Namibia",
    nz: "New Zealand",
    sc: "Seychelles",
    sz: "Eswatini",
    tz: "Tanzania",
    us: "United States",
    za: "South Africa",
    zm: "Zambia",
    zw: "Zimbabwe",
  },
  zu: {
    ao: "i-Angola",
    au: "i-Australia",
    ae: "i-United Arab Emirates",
    be: "i-Belgium",
    bw: "iBotswana",
    ca: "i-Canada",
    cd: "i-DR Congo",
    ch: "iSwitzerland",
    de: "i-Germany",
    fr: "iFrance",
    gb: "i-United Kingdom",
    gh: "iGhana",
    ls: "iLesotho",
    mg: "i-Madagascar",
    mu: "iMauritius",
    mw: "iMalawi",
    mz: "iMozambique",
    na: "iNamibia",
    nz: "i-New Zealand",
    sc: "iSeychelles",
    sz: "iSwatini",
    tz: "iTanzania",
    us: "i-United States",
    za: "iNingizimu Afrika",
    zm: "iZambia",
    zw: "iZimbabwe",
  },
};

export function getAuditLocale(code) {
  return normalizeLocale(code);
}

export function isAuditLocale(code) {
  return AUDIT_LOCALES.has(normalizeLocale(code));
}

export function shouldHideUntranslatedCatalog(code) {
  return isAuditLocale(code);
}

export function getLocalizedMarketName(market, languageCode) {
  const locale = normalizeLocale(languageCode);
  const iso = normalizeLocale(market?.iso);
  const explicitLabel = MARKET_NAME_LABELS[locale]?.[iso];
  if (explicitLabel) return explicitLabel;
  // Market names are controlled picker options, not persisted record values.
  // Use the platform’s French region vocabulary so create forms do not fall
  // back to English country labels while preserving stored addresses elsewhere.
  if (locale === "fr" && /^[a-z]{2}$/.test(iso) && typeof Intl.DisplayNames === "function") {
    try {
      return new Intl.DisplayNames(["fr"], { type: "region" }).of(iso.toUpperCase()) || market?.name || "";
    } catch {
      // Older runtimes retain the canonical market fallback below.
    }
  }
  return market?.name || "";
}
